// removed by extract-text-webpack-plugin
module.exports = {"NavItems":"NavItems__NavItems__3tJQu"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Navigation/NavItems/NavItems.css
// module id = 139
// module chunks = 0